/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetKernelSizesForPickerQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetKernelSizesForPickerQuery = {
  readonly __typename: "Query";
  readonly getKernelSizesV2: {
    readonly __typename: "KernelSizesConfig";
    readonly default: c.KernelSize;
    readonly isFreeTrial: boolean;
    readonly options: ReadonlyArray<{
      readonly __typename: "KernelSizeConfigV2";
      readonly id: c.KernelSize;
      readonly humanName: string;
      readonly memoryLimit: number;
      readonly cpuLimit: number;
      readonly disabled: boolean;
      readonly disabledReason: Types.ComputeProfileDisabledReason | null;
      readonly gpuLimit: number;
      readonly requiresPayment: boolean;
      readonly hourlyCostHumanReadable: string | null;
    }>;
  } | null;
};

export type GetOrgAllowPaidComputeQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetOrgAllowPaidComputeQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly allowPaidCompute: boolean;
    readonly isSelfServe: boolean;
    readonly computeSpendDetails: {
      readonly __typename: "ComputeSpendDetails";
      readonly paidComputeDisabledDueToSpendLimit: boolean;
    } | null;
  };
};

export type UserConfirmedPaidComputeQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UserConfirmedPaidComputeQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly confirmedPaidCompute: boolean;
  } | null;
};

export type OrgAllowPaidComputeUpdatedSubscriptionVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type OrgAllowPaidComputeUpdatedSubscription = {
  readonly __typename: "Subscription";
  readonly orgAllowPaidComputeUpdated: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly allowPaidCompute: boolean;
  };
};

export const GetKernelSizesForPickerDocument = /*#__PURE__*/ gql`
  query GetKernelSizesForPicker {
    getKernelSizesV2 {
      options {
        id
        humanName
        memoryLimit
        cpuLimit
        disabled
        disabledReason
        gpuLimit
        requiresPayment
        hourlyCostHumanReadable
      }
      default
      isFreeTrial
    }
  }
`;

/**
 * __useGetKernelSizesForPickerQuery__
 *
 * To run a query within a React component, call `useGetKernelSizesForPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKernelSizesForPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKernelSizesForPickerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKernelSizesForPickerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetKernelSizesForPickerQuery,
    GetKernelSizesForPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetKernelSizesForPickerQuery,
    GetKernelSizesForPickerQueryVariables
  >(GetKernelSizesForPickerDocument, options);
}
export function useGetKernelSizesForPickerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetKernelSizesForPickerQuery,
    GetKernelSizesForPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetKernelSizesForPickerQuery,
    GetKernelSizesForPickerQueryVariables
  >(GetKernelSizesForPickerDocument, options);
}
export function useGetKernelSizesForPickerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetKernelSizesForPickerQuery,
    GetKernelSizesForPickerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetKernelSizesForPickerQuery,
    GetKernelSizesForPickerQueryVariables
  >(GetKernelSizesForPickerDocument, options);
}
export type GetKernelSizesForPickerQueryHookResult = ReturnType<
  typeof useGetKernelSizesForPickerQuery
>;
export type GetKernelSizesForPickerLazyQueryHookResult = ReturnType<
  typeof useGetKernelSizesForPickerLazyQuery
>;
export type GetKernelSizesForPickerSuspenseQueryHookResult = ReturnType<
  typeof useGetKernelSizesForPickerSuspenseQuery
>;
export type GetKernelSizesForPickerQueryResult = Apollo.QueryResult<
  GetKernelSizesForPickerQuery,
  GetKernelSizesForPickerQueryVariables
>;
export const GetOrgAllowPaidComputeDocument = /*#__PURE__*/ gql`
  query GetOrgAllowPaidCompute($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      allowPaidCompute
      isSelfServe
      computeSpendDetails {
        paidComputeDisabledDueToSpendLimit
      }
    }
  }
`;

/**
 * __useGetOrgAllowPaidComputeQuery__
 *
 * To run a query within a React component, call `useGetOrgAllowPaidComputeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgAllowPaidComputeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgAllowPaidComputeQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgAllowPaidComputeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgAllowPaidComputeQuery,
    GetOrgAllowPaidComputeQueryVariables
  > &
    (
      | { variables: GetOrgAllowPaidComputeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgAllowPaidComputeQuery,
    GetOrgAllowPaidComputeQueryVariables
  >(GetOrgAllowPaidComputeDocument, options);
}
export function useGetOrgAllowPaidComputeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgAllowPaidComputeQuery,
    GetOrgAllowPaidComputeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgAllowPaidComputeQuery,
    GetOrgAllowPaidComputeQueryVariables
  >(GetOrgAllowPaidComputeDocument, options);
}
export function useGetOrgAllowPaidComputeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgAllowPaidComputeQuery,
    GetOrgAllowPaidComputeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgAllowPaidComputeQuery,
    GetOrgAllowPaidComputeQueryVariables
  >(GetOrgAllowPaidComputeDocument, options);
}
export type GetOrgAllowPaidComputeQueryHookResult = ReturnType<
  typeof useGetOrgAllowPaidComputeQuery
>;
export type GetOrgAllowPaidComputeLazyQueryHookResult = ReturnType<
  typeof useGetOrgAllowPaidComputeLazyQuery
>;
export type GetOrgAllowPaidComputeSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgAllowPaidComputeSuspenseQuery
>;
export type GetOrgAllowPaidComputeQueryResult = Apollo.QueryResult<
  GetOrgAllowPaidComputeQuery,
  GetOrgAllowPaidComputeQueryVariables
>;
export const UserConfirmedPaidComputeDocument = /*#__PURE__*/ gql`
  query UserConfirmedPaidCompute {
    me {
      id
      confirmedPaidCompute
    }
  }
`;

/**
 * __useUserConfirmedPaidComputeQuery__
 *
 * To run a query within a React component, call `useUserConfirmedPaidComputeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserConfirmedPaidComputeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserConfirmedPaidComputeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserConfirmedPaidComputeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserConfirmedPaidComputeQuery,
    UserConfirmedPaidComputeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserConfirmedPaidComputeQuery,
    UserConfirmedPaidComputeQueryVariables
  >(UserConfirmedPaidComputeDocument, options);
}
export function useUserConfirmedPaidComputeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserConfirmedPaidComputeQuery,
    UserConfirmedPaidComputeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserConfirmedPaidComputeQuery,
    UserConfirmedPaidComputeQueryVariables
  >(UserConfirmedPaidComputeDocument, options);
}
export function useUserConfirmedPaidComputeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserConfirmedPaidComputeQuery,
    UserConfirmedPaidComputeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserConfirmedPaidComputeQuery,
    UserConfirmedPaidComputeQueryVariables
  >(UserConfirmedPaidComputeDocument, options);
}
export type UserConfirmedPaidComputeQueryHookResult = ReturnType<
  typeof useUserConfirmedPaidComputeQuery
>;
export type UserConfirmedPaidComputeLazyQueryHookResult = ReturnType<
  typeof useUserConfirmedPaidComputeLazyQuery
>;
export type UserConfirmedPaidComputeSuspenseQueryHookResult = ReturnType<
  typeof useUserConfirmedPaidComputeSuspenseQuery
>;
export type UserConfirmedPaidComputeQueryResult = Apollo.QueryResult<
  UserConfirmedPaidComputeQuery,
  UserConfirmedPaidComputeQueryVariables
>;
export const OrgAllowPaidComputeUpdatedDocument = /*#__PURE__*/ gql`
  subscription OrgAllowPaidComputeUpdated($orgId: OrgId!) {
    orgAllowPaidComputeUpdated(orgId: $orgId) {
      id
      allowPaidCompute
    }
  }
`;

/**
 * __useOrgAllowPaidComputeUpdatedSubscription__
 *
 * To run a query within a React component, call `useOrgAllowPaidComputeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrgAllowPaidComputeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgAllowPaidComputeUpdatedSubscription({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useOrgAllowPaidComputeUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OrgAllowPaidComputeUpdatedSubscription,
    OrgAllowPaidComputeUpdatedSubscriptionVariables
  > &
    (
      | {
          variables: OrgAllowPaidComputeUpdatedSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OrgAllowPaidComputeUpdatedSubscription,
    OrgAllowPaidComputeUpdatedSubscriptionVariables
  >(OrgAllowPaidComputeUpdatedDocument, options);
}
export type OrgAllowPaidComputeUpdatedSubscriptionHookResult = ReturnType<
  typeof useOrgAllowPaidComputeUpdatedSubscription
>;
export type OrgAllowPaidComputeUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<OrgAllowPaidComputeUpdatedSubscription>;
